import './SpecialOffers.scss';
import testImage from '../../../assets/images/banner2.jpg';


const SpecialOffers = ({ image, layoutClass }) => {
    const assetUrl = process.env.REACT_APP_TAURIAN_ASSET_URL;
    return (
        <div className={`special-offers ${layoutClass}`}>
            <img src={`${assetUrl}${image}`} />
        </div>
    );
}

export default SpecialOffers;
